import { Link, Outlet } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

/** Compact chrome for SSH/RDP/VNC sessions — no sidebar, full-bleed content. */
export default function SessionChrome() {
  return (
    <div className="flex h-screen flex-col bg-background">
      <header className="flex h-12 shrink-0 items-center gap-3 border-b border-border bg-surface px-4">
        <Link
          to="/catalog"
          className="inline-flex items-center gap-2 rounded-lg px-2 py-1.5 text-sm text-muted hover:bg-surface-muted hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to resources
        </Link>
        <span className="text-sm font-semibold text-primary">Idefy</span>
      </header>
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
    </div>
  )
}
